import { cn } from '@atlas/ui-primitives'

export interface ScopeToggleProps<T extends string> {
	/** The choices, in display order. */
	options: ReadonlyArray<{ value: T; label: string }>
	value: T
	onChange: (value: T) => void
	/** Accessible name for the group, e.g. "Show orders". */
	label: string
}

/** A pill-shaped segmented choice between whose orders a work-order view shows. */
export function ScopeToggle<T extends string>({ options, value, onChange, label }: ScopeToggleProps<T>) {
	return (
		<div
			role="group"
			aria-label={label}
			className="flex items-center rounded-ds-full border border-ds-border bg-ds-surface-elevated p-0.5"
		>
			{options.map((option) => (
				<button
					key={option.value}
					type="button"
					aria-pressed={value === option.value}
					onClick={() => onChange(option.value)}
					className={cn(
						'whitespace-nowrap rounded-ds-full px-3 py-1 text-sm font-medium transition-colors',
						value === option.value ? 'bg-ds-primary text-ds-background' : 'text-ds-text-muted hover:text-ds-text',
					)}
				>
					{option.label}
				</button>
			))}
		</div>
	)
}
